import { Grid, TextField } from "@mui/material";
import React, { ChangeEvent } from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { FormCheckBox } from "../../../framework/FormCheckBox";
import { FormField } from "../../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../../framework/Grid/GridRow";
import { IAppReportTemplateEditItem } from "ui/Scripts/source/models/appReportTemplate/appReportTemplateEditItem";

interface IAppReportTemplateDialogBasicInformationProps {
    code: string;
    comment: string;
    activeState: number;
    item: IAppReportTemplateEditItem;
    isNew: boolean;
    onHandleChange: (event: ChangeEvent) => void;
    onUpdateActiveState: (activeState: number) => void;
}

export const AppReportTemplateDialogBasicInformation = (props: IAppReportTemplateDialogBasicInformationProps) => {
    return <>
        <GridRow container>
            <Grid item sm={10}>
                <FormField title={Translations.Name} fullWidth required margin="0">
                    <TextField name="code" title={Translations.Code} inputProps={{
                        maxLength: 50
                    }} value={props.code} required={true} onChange={props.onHandleChange} size="small" fullWidth disabled={!props.isNew} autoFocus={props.isNew} />
                </FormField>
            </Grid>
            <Grid item sm={2}>
                <FormField fullWidth title={<span>&nbsp;</span>} margin="0">
                    <FormCheckBox title={Translations.InUse} checked={props.activeState > 0} onChange={(checked: boolean) => props.onUpdateActiveState(checked ? 1 : 0)} />
                </FormField>
            </Grid>
        </GridRow>
        <GridRow>
            <Grid item sm={12}>
                <FormField title={Translations.Description} fullWidth>
                    <TextField name="comment" title={Translations.Description} inputProps={{
                        maxLength: 1000
                    }} value={props.comment} onChange={props.onHandleChange} multiline rows={8} size="small" fullWidth />
                </FormField>
            </Grid>
        </GridRow>
    </>;
};
